import { useTranslation } from 'react-i18next'

import { Flex } from '@enechain/ecloud-designsystem'

import { GcCountdownPill } from '~/components/common/GcCountdownPill'
import type { GateCloseFrontier } from '~/models/gateClose'
import { komaNumberTimeRange } from '~/models/komaToTime'

import { useGcCountdown } from './useGcCountdown'

type Props = {
  frontier: GateCloseFrontier | undefined
  gcKoma: number
  /** 表示中の日付。当日以外は描画しない (spec AC-BDB-022 / AC-BDH-019b)。 */
  displayDate: Date
}

/** 同時同量詳細の次のGC (AC-BDB-021 / AC-BDH-019b)。当日以外は行ごと非表示。 */
export const GcCountdownCard = ({
  gcKoma,
  frontier,
  displayDate,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  const gcCountdown = useGcCountdown(frontier, displayDate)

  if (gcCountdown === null) {
    return null
  }

  return (
    // design `.summary-gc-row`: 右端に寄せ、 下の要素との間を 8px 空ける
    <Flex justifyContent="flex-end" flexShrink={0} marginBottom="8px">
      <GcCountdownPill
        remaining={gcCountdown.text}
        slot={{
          koma: gcKoma + 1,
          range: komaNumberTimeRange(
            gcKoma + 1,
            t('common:gcCountdown.rangeSeparator'),
          ),
        }}
        urgent={gcCountdown.isUrgent}
      />
    </Flex>
  )
}
